import { tv } from 'tailwind-variants'
import { cn } from '@scalis/utils'

export const inputMaskClassname = tv({
  base: cn(
    'border-neutral-00 bg-background placeholder:text-muted-foreground focus-visible:ring-ring flex h-9 w-full rounded-md border px-3 py-1 text-sm shadow-xs transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-hidden focus-visible:ring-1 disabled:cursor-not-allowed disabled:opacity-50',
  ),
})
